module.exports = __webpack_public_path__ + "assets/images/ios_push_notification-f6f8a952fb81cccac72337aa7dbfd6fe.mp4";